import { Menu } from './menu.model';



    export const verticalMenuItems = [
        new Menu(1, 'ADMIN_NAV.DASHBOARD', '/', null, 'tachometer', null, false, 0),
        new Menu(201, "Organization", 'views/organization', null, 'building', null, false, 0),
        new Menu(202, "People", 'views/people', null, 'user', null, false, 0),
        new Menu(203, "Teams", 'views/teams', null, 'group', null, false, 0),
        new Menu(204, "Pakages", 'views/packages', null, 'shopping-bag', null, false, 0),
        new Menu(205, "Reports", 'views/reports', null, 'th-list', null, false, 0),

    ]

    export const verticalMenuItems1 = [
        new Menu(1, 'ADMIN_NAV.DASHBOARD', '/', null, 'tachometer', null, false, 0),
        new Menu(201, "Organization", 'views/organization', null, 'building', null, false, 0),
        new Menu(202, "People", 'views/people', null, 'user', null, false, 0),
        new Menu(203, "Teams", 'views/teams', null, 'group', null, false, 0),
        new Menu(204, "Item", 'views/item', null, 'group', null, false, 0),
        new Menu(205, "Reports", 'views/reports', null, 'th-list', null, false, 0),

    ]

export const horizontalMenuItems = [
    new Menu(1, 'ADMIN_NAV.DASHBOARD', '/', null, 'tachometer', null, false, 0),
    new Menu(40, 'ADMIN_NAV.PAGES', null, null, 'file-text-o', null, true, 0),
    new Menu(43, 'LOGIN', '/login', null, 'sign-in', null, false, 0),
    new Menu(44, 'REGISTER', '/register', null, 'registered', null, false, 0),
    new Menu(45, 'ADMIN_NAV.BLANK', '/blank', null, 'file-o', null, false, 40),
    new Menu(46, 'ADMIN_NAV.ERROR', '/pagenotfound', null, 'exclamation-circle', null, false, 40),
    new Menu(200, 'ADMIN_NAV.EXTERNAL_LINK', null, 'http://themeseason.com', 'external-link', '_blank', false, 0)
]